import { UpdateDocumentNoteStepCard } from "@/features/renew-visa/components/updateDocumentNoteStep/UpdateDocumentNoteStepCard";
import { FC } from "react";

export type TRenewVisaUpdateDocumentNoteStepProps = {
  readonly?: boolean;
};

export const RenewVisaUpdateDocumentNoteStep: FC<TRenewVisaUpdateDocumentNoteStepProps> = ({ readonly }) => {
  return <UpdateDocumentNoteStepCard readonly={readonly} />;
};
